import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6225b578"
import script from "./customerHistory?vue&type=script&lang=js&external"
export * from "./customerHistory?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports